<script setup>
import IndexLayout from "@/Layouts/IndexLayout.vue";
import FAQAccordion from "@/Components/FAQAccordion.vue";
import {trans} from "laravel-vue-i18n";
import {computed} from "vue";
import {HelpDeskUrl, tgSupportUrl} from "@/constants.js";
import ParticipateButton from "@/Components/ParticipateButton.vue";

const helpCenterStr = computed(() => `<a class="text-blue-400 underline" href="${HelpDeskUrl}" target="_blank">${trans('Help Center')}</a>`);
const telegramStr = computed(() => `<a href="${tgSupportUrl}" class="text-blue-400 underline" target="_blank">${trans('Telegram')}</a>`);
</script>


<template>
    <IndexLayout :title="$t('Referral program')">
        <div class="pt-3 pb-5 md:max-w-5xl sm:max-w-2xl m-auto flex justify-between relative">
            <div class="pt-5 px-10 pb-16 md:w-1/2 sm:w-full z-10">
                <h1 class="font-sans text-white text-base sm:text-xl tracking-wider mb-3">
                    {{ $t('Referral program') }} ANYKOD
                </h1>
                <h2 class="font-['Unbounded'] text-white text-2.5xl lg:text-3.4xl lg:text-3xl mb-3">
                    {{ $t('Bring new users to ANYKOD and earn money') }}
                </h2>
                <p v-html="$t(':inviter for each new user to you and <br/> :invited to the invited. <br/>More users - more earnings.', {
                    inviter: $t('1 USD'),
                    invited: $t('1 USD')
                })" class="text-base font-sans text-white font-regular tracking-wider mb-8">

                </p>
                <div class="md:block flex justify-center">
                    <ParticipateButton/>
                </div>
            </div>
            <div class="sm:max-w-sm 2xl:max-w-md absolute z-0 top-1/4 sm:top-0 -right-24 md:right-0">
                <img alt="marketing" class="max-w-xs sm:max-w-sm 2xl:max-w-md" src="/assets/img/referral-landing/marketing.webp">
            </div>
        </div>
        <div class="bg-dark-blue py-5 w-full">
            <div class="max-w-5xl m-auto">
                <h1 class="font-['Unbounded'] text-white text-2xl sm:text-2.5xl text-center mb-5 px-5">
                    {{ $t('Why participate in the program?') }}
                </h1>
                <div class="flex flex-col lg:flex-row items-center lg:items-stretch lg:justify-between lg:mb-2.5 px-5">
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-deep-blue max-w-xl w-full lg:w-1/2 mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img alt="first-advantage" src="/assets/img/referral-landing/advantages/1.gif" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Real money') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('The money earned through the referral program can not only be spent on the anykod.com website, but also withdrawn!')
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-deep-blue max-w-xl w-full lg:w-1/2  mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img alt="second-advantage" src="/assets/img/referral-landing/advantages/2.gif" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Any social networks and messengers') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('Post your referral link in any social networks, on any websites and forums, send it to your friends in any messengers and earn! The link works everywhere!')
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col lg:flex-row items-center lg:items-stretch lg:justify-between lg:mb-2.5 px-5">
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-deep-blue max-w-xl w-full lg:w-1/2  mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img alt="third-advantage" src="/assets/img/referral-landing/advantages/3.gif" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Support Service') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('You will be assisted by a support team that will be happy to answer any questions and solve problems.')
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-deep-blue max-w-xl w-full lg:w-1/2  mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img alt="fourth-advantage" src="/assets/img/referral-landing/advantages/4.gif" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Accurate tracking') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('After registering a new user on your link, the system automatically counts it. In the “Referral program” section in your personal cabinet you can see the number of registered users using your link and the amount of money earned.')
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="mt-4 flex justify-center">
                    <ParticipateButton/>
                </div>
            </div>
        </div>
        <div class="py-5 w-full">
            <div class="max-w-5xl m-auto">
                <h1 id="how-it-works"
                    class="font-['Unbounded'] text-white text-2xl sm:text-2.5xl text-center mb-5 px-5">
                    {{ $t('How it works?') }}
                </h1>
                <div class="flex flex-col lg:flex-row items-center lg:items-stretch lg:justify-between lg:mb-2.5 px-5">
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-dark-blue max-w-xl w-full lg:w-1/2 mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img src="/assets/img/referral-landing/how-it-works/1.svg" alt="first-step" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Register on the website') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('and subscribe to our Telegram bot in the settings in your personal cabinet.')
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-dark-blue max-w-xl w-full lg:w-1/2  mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img src="/assets/img/referral-landing/how-it-works/2.svg" alt="second-step" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Copy your personal referral link') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('in the “Referral Program” section in your personal cabinet. Post this link in your social networks or forward it to your friends. Better yet, do both.')
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col lg:flex-row items-center lg:items-stretch lg:justify-between lg:mb-2.5 px-5">
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-dark-blue max-w-xl w-full lg:w-1/2 mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img src="/assets/img/referral-landing/how-it-works/3.svg" alt="third-step" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Get 1 USD for each invitee') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('when he registers on the site, subscribes to our Telegram bot and makes a purchase or sales of 2 USD or more (bonus funds are not taken into account).')
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-dark-blue max-w-xl w-full lg:w-1/2  mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img src="/assets/img/referral-landing/how-it-works/4.svg" alt="fourth-step" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t("We'll immediately credit 1 USD") }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('to the invitee as soon as he registers and subscribes to our Telegram bot.')
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col lg:flex-row items-center lg:items-stretch lg:justify-between lg:mb-2.5 px-5">
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-dark-blue max-w-xl w-full lg:w-1/2 mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img src="/assets/img/referral-landing/how-it-works/5.svg" alt="fifth-step" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Keep track of your earnings') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('in the “Referral Program” section of my personal cabinet. Accruals are made for each new user you refer who fulfills the terms of the program. More users - more earnings.')
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        class="p-3 mb-2.5 lg:mb-0 bg-dark-blue max-w-xl w-full lg:w-1/2  mx-1.5 flex justify-between items-stretch rounded-lg">
                        <div>
                            <img src="/assets/img/referral-landing/how-it-works/6.svg" alt="sixth-step" style="width: 40px; height: 40px">
                        </div>
                        <div class="w-fit ml-3">
                            <h3 class="text-base mb-1 font-sans text-white font-medium uppercase tracking-wider">
                                {{ $t('Withdraw or spend') }}
                            </h3>
                            <p class="text-base font-sans text-white font-normal leading-none tracking-wider">
                                {{
                                    $t('earned money on the site. You can use your internal wallet to pay up to 100% of the price. You can withdraw in the “Referral Program” or “Wallet” section - just click on the “Withdraw Money” button.')
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 flex justify-center">
                <ParticipateButton/>
            </div>
            <div class="py-20 w-full">
                <h1 class="font-['Unbounded'] text-white text-2xl sm:text-2.5xl text-center mb-16 px-5">
                    {{ $t('FAQ') }}
                </h1>
                <div class="max-w-2xl lg:max-w-xl  flex flex-col items-center m-auto px-5">
                    <FAQAccordion>
                        <template #question>
                            {{ $t('Is there a limit on the number of new users attracted?') }}
                        </template>
                        <template #answer>
                            {{ $t("There's no limit. Bring everyone!") }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('When do I get paid for a referred user?') }}
                        </template>
                        <template #answer>
                            {{
                                $t('Money is credited immediately after a new user has registered on the site, subscribed to our Telegram bot and made a purchase/sale (or several purchases/sales), where a minimum of 2 USD was spent in total (bonus funds are not taken into account). Accruals are made for each user who fulfilled the terms of the program.')
                            }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('When is the money credited to the person I brought in?') }}
                        </template>
                        <template #answer>
                            {{
                                $t('100 rubles are credited to a new user immediately after he registered on the site and subscribed to our Telegram-bot in the settings in the personal cabinet of the site.')
                            }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('When can I withdraw my money?') }}
                        </template>
                        <template #answer>
                            {{
                                $t('According to the site rules, money can be withdrawn 24 hours after credited to the wallet.')
                            }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('Are there any restrictions on the minimum withdrawal amount?') }}
                        </template>
                        <template #answer>
                            {{ $t('The minimum withdrawal amount is 2 USD.') }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('How much money can I earn?') }}
                        </template>
                        <template #answer>
                            {{
                                $t('The total amount of reward under the referral program is up to 500 USD per user.')
                            }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('Who can participate in the program?') }}
                        </template>
                        <template #answer>
                            {{ $t('Any user registered on the site can participate in the referral program.') }}
                        </template>
                    </FAQAccordion>
                    <FAQAccordion>
                        <template #question>
                            {{ $t('The other question?') }}
                        </template>
                        <template #answer>
                            <span v-html="$t('Write to us in the :helpCenter or to our support in :telegram', {
                                helpCenter: helpCenterStr,
                                telegram: telegramStr
                            })"></span>

                        </template>
                    </FAQAccordion>
                </div>
            </div>
        </div>
    </IndexLayout>
</template>
